<script>
    import { Bar } from 'vue-chartjs'


    export default {
        extends: Bar,
        props: ['chartdata', 'options'],

        /* >>> *************************************************************** / /* Data */
        data: () => ({
            // chartdata: {
            //     labels: ['September', 'Oktober', 'November', 'Dezember', 'January', 'February', ],
            //     datasets: [
            //         {
            //             label: 'Flightprices',
            //             backgroundColor: '#f87979',
            //             data: [72, 82, 62, 62]
            //         },
            //     ]
            // },
            // options: {
            //     responsive: true,
            //     maintainAspectRatio: false
            // }
        }), // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function () {

            let me = this;


            me.$toc('>>> shared/charts/KeyDestinationsBarChart.vue >>> mounted');
            this.renderChart(this.chartdata, this.options);

        }, // eo function mounted()

        /***********************************************************************
        * Lifecyclehook::beforeUpdate
        *
        * Desc:
        * Note:
        *
        */
        beforeUpdate: function () {

            let me = this;


            me.$toc('>>> shared/charts/KeyDestinationsBarChart.vue >>> beforeUpdate');

        }, // eo function beforeUpdate()

        /***********************************************************************
        * Lifecyclehook::updated
        *
        * Desc:
        * Note:
        *
        */
        updated: function () {

            let me = this;


            me.$toc('>>> shared/charts/KeyDestinationsBarChart.vue >>> updated');

        }, // eo function updated()

    }
</script>

<style>
</style>





// WEBPACK FOOTER //
// src/components/shared/charts/KeyDestinationsBarChart.vue